import request from "@/utils/request";

export function submit(data) {
  return request({
    url: "/OldStudent/Submit",
    method: "post",
    data
  });
}
export function getBaseInfo(params) {
  return request({
    url: "/OldStudent/GetBaseInfo",
    method: "get",
    params
  });
}
export function getResult(params) {
  return request({
    url: "/OldStudent/GetHostelApplicationResult",
    method: "get",
    params
  });
}
export function getTime(params) {
  return request({
    url: "/OldStudent/SearchCheckOutDate",
    method: "get",
    params
  });
}
export function getReturnList(params) {
  return request({
    url: "/OvernightApplication/GetHistoryRecord",
    method: "get",
    params
  });
}
